import React, { useState, useEffect, useRef } from "react";
import { POST, PUT, GET, newFetch } from "../../../../helpers/fetch";
import { config } from "../../../../config/index";
import Modal from "react-modal";
import ToastUtil from "../../../../components/ToastNotification/ToastUtil";
const FaceVerification = ({
  user,
  type,
  imgSrc,
  src,
  videoRef,
  faceapi,
  clockIn,
  showModalFaceVerification,
  setShowModalFaceVerification,
  setShowModalClockInOut,
}) => {
  const canvasRef = useRef();
  const videoHeight = 290;
  const videoWidth = 400;
  const [initializing, setInitializing] = useState(true);
  const [faceVerificationInterval, setFaceVerificationInterval] = useState();
  const [counter, setCounter] = useState(0);

  const padding2 = 120; // adjust this to your needs
  let height2 = 295 + padding2;
  let heightPx2 = height2 + "px";
  let heightOffset2 = height2 / 2;
  let offsetPx2 = heightOffset2 + "px";

  const style2 = {
    border: "0",
    borderRadius: "20px",
    bottom: "auto",
    height: heightPx2, // set height
    left: "50%",
    padding: "2rem",
    position: "fixed",
    right: "auto",
    top: "40%", // start from center
    transform: "translate(-50%,-" + offsetPx2 + ")", // adjust top "up" based on height
    width: "90%",
    overflow: "hidden",
    maxWidth: "420px",
  };

  const handleCloseModalFaceVerification = async () => {
    setInitializing(false);
    await clearInterval(faceVerificationInterval);
    await setShowModalFaceVerification(false);
    if (videoRef.current?.srcObject == null) {
      await src.getVideoTracks().forEach((track) => {
        track.stop();
        src.removeTrack(track);
      });
    } else {
      await videoRef.current.srcObject.getVideoTracks().forEach((track) => {
        track.stop();
        videoRef.current.srcObject.removeTrack(track);
      });
      //video.srcObject.getTracks()[0].stop();
    }
  };

  const captureSnapshot = async () => {
    let ctx = canvasRef.current.getContext("2d");
    let img = new Image();
    ctx.drawImage(videoRef.current, 0, 0, videoWidth, videoHeight);
    img.src = canvasRef.current.toDataURL("image/jpeg");
    img.width = 420;
    let snapshot = canvasRef.current.toDataURL("image/jpeg");
    let api_path = `/associate/${user.id}/save_verified_img`;
    let response = await newFetch(POST, api_path, { snapshot, type });
    if (response.success) {
      //ToastUtil.success("success")
    }
  };

  const handleVideoOnPlay = () => {
    let verifyFace = setInterval(async () => {
      if (initializing) {
        setInitializing(false);
      }

      canvasRef.current.innerHTML = faceapi.createCanvasFromMedia(
        videoRef.current
      );
      const displaySize = {
        width: videoWidth,
        height: videoHeight,
      };

      const descriptions = [];
      const img = await faceapi.fetchImage(`${config.SERVER_URL}/${imgSrc}`);
      const detections2 = await faceapi
        .detectSingleFace(
          img,
          new faceapi.TinyFaceDetectorOptions({
            inputSize: 160,
            scoreThreshold: 0.8,
          })
        )
        .withFaceLandmarks()
        .withFaceDescriptor();

      descriptions.push(detections2.descriptor);

      const labeledDescriptors = [
        new faceapi.LabeledFaceDescriptors("Verified", descriptions),
      ];
      const faceMatcher = new faceapi.FaceMatcher(labeledDescriptors, 0.33);

      if (canvasRef.current != null) {
        faceapi.matchDimensions(canvasRef.current, displaySize);

        const detections = await faceapi
          .detectSingleFace(
            videoRef.current,
            new faceapi.TinyFaceDetectorOptions({
              inputSize: 160,
              scoreThreshold: 0.85,
            })
          )
          .withFaceLandmarks()
          .withFaceDescriptor();
        //.withFaceExpressions()

        if (detections && showModalFaceVerification == true) {
          const resizedDetections = faceapi.resizeResults(
            detections,
            displaySize
          );
          const bestMatch = faceMatcher.findBestMatch(detections.descriptor);
          canvasRef.current
            .getContext("2d")
            .clearRect(0, 0, videoWidth, videoHeight);
          //faceapi.draw.drawDetections(canvasRef.current, resizedDetections)
          //faceapi.draw.drawFaceLandmarks(canvasRef.current, resizedDetections, { drawLines: false })

          //// DRAW a custom box ////
          const box = {
            x: resizedDetections.detection.box.x,
            y: resizedDetections.detection.box.y,
            width: resizedDetections.detection.box.width,
            height: resizedDetections.detection.box.height,
          };
          const drawOptions = {
            // label: 'name',
            lineWidth: 2,
          };
          const drawBox = new faceapi.draw.DrawBox(box, drawOptions);
          drawBox.draw(canvasRef.current);
          let landmarkPositions = resizedDetections.landmarks.positions;
          let ctx = canvasRef.current.getContext("2d");

          //looping over landmarks to draw the canvas
          for (let i = 0; i < landmarkPositions.length; i++) {
            let x_val = landmarkPositions[i]._x;
            let y_val = landmarkPositions[i]._y;
            ctx.beginPath();
            ctx.arc(x_val, y_val, 1, 0, Math.PI * 2, false);
            ctx.fillStyle = "#CECCCB";
            ctx.fill();
            ctx.closePath();
          }

          if (bestMatch.label === "Verified") {
            captureSnapshot();
            clearInterval(verifyFace);
            setShowModalFaceVerification(false);
            ToastUtil.success(`Face Recognized!`);
            setCounter(0);
            handleCloseModalFaceVerification();
            setShowModalClockInOut(false);
            clockIn();
          }
        }
      }
      setCounter((prevCount) => prevCount + 1);
    }, 1000);

    setFaceVerificationInterval(verifyFace);
  };

  useEffect(() => {
    if (counter > 15) {
      //clearInterval(verifyFace)
      setShowModalFaceVerification(false);
      handleCloseModalFaceVerification();
      setShowModalClockInOut(false);
      setCounter(0);
      ToastUtil.error(
        "Sorry, failed to recognize your face id. You may be not registered to this client or please try again."
      );
    }
  }, [counter]);

  return (
    <Modal
      ariaHideApp={false}
      isOpen={showModalFaceVerification}
      style={{
        overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
        content: style2,
      }}
    >
      <div className="d-flex flex-column h-100">
        <div className="text-center">
          {initializing ? <h5>Face Verification</h5> : <h5>Processing...</h5>}
        </div>
        <div className="d-flex justify-content-center">
          <video
            id="stream"
            ref={videoRef}
            playsInline
            width="400"
            height="290"
            onPlay={handleVideoOnPlay}
            autoPlay
          ></video>
          <canvas
            id="capture"
            width="400"
            height="290"
            ref={canvasRef}
            className="position-absolute"
          ></canvas>
        </div>
        <div className="d-flex justify-content-center mt-auto pt-3">
          <span>
            <button
              id="btn-start"
              onClick={handleCloseModalFaceVerification}
              type="button"
              className="btn btn-brand btn-block"
              style={{ width: "100px" }}
            >
              Cancel
            </button>
          </span>
        </div>
      </div>
    </Modal>
  );
};

export default FaceVerification;
